<mat-card>
  <form [formGroup]="formActualizaComplemento">
    <div class="row m-0 py-4 px-2">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Responsable:</mat-label>
              <mat-select formControlName="responsable" placeholder="Seleccionar">
                @for (r of responsables; track r) {
                  <mat-option [value]="r.id">{{ r.nombre }}</mat-option>
                }
              </mat-select>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <mat-form-field class="inputFormularioSmall"
              [ngClass]="cesvi.estatus_cesvi == 1 ? 'bg-serie-verde' : ''">
              <mat-label>Serie: @if (cesvi.estatus_cesvi == 1) {
                <span class="txt-exito"
                [innerHTML]="verificaSerieHTMLSa"></span>
              }</mat-label>
              <input matInput type="text" formControlName="serie" maxlength="17">
              @if (formActualizaComplemento.get('serie')?.hasError('required')) {
                <mat-error>
                  Campo requerido
                </mat-error>
              }
              @if (formActualizaComplemento.get('serie')?.hasError('incorrecta')) {
                <mat-error>
                  <strong>Verifica la serie ingresada</strong>
                </mat-error>
              }
              @if (formActualizaComplemento.get('serie')?.hasError('incorrecta')) {
                <mat-icon class="txt-error hand-cursor"
                  matSuffix
                  #menuTrigger="matMenuTrigger" [matMenu] (click)="menuTrigger.openMenu()"
                  [matMenuTriggerFor]="menu">
                  error_outline
                </mat-icon>
              }
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Edad conductor:</mat-label>
              <input matInput type="text" [OnlyNumber]="true" formControlName="edadConductor"
                maxlength="3">
                @if (this.formActualizaComplemento.get('edadConductor').hasError('required')) {
                  <mat-error
                    >Campo
                  requerido</mat-error>
                }
                @if (this.formActualizaComplemento.get('edadConductor').hasError('importeInvalido')) {
                  <mat-error
                    >El
                  valor debe ser diferente de 0</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field class="inputFormularioSmall">
                <mat-label>Sexo conductor:</mat-label>
                <mat-select formControlName="sexoConductor" placeholder="Seleccionar">
                  @for (s of sexos; track s) {
                    <mat-option [value]="s.valor_dato">
                      {{ s.descripl_dato }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>El campo debe tener un valor</mat-error>
              </mat-form-field>

            </div>
            <div class="col-md-12">
              <mat-form-field class="inputFormularioSmall">
                <mat-label>E-mail:</mat-label>
                <input matInput type="email" formControlName="email">
                @if (this.formActualizaComplemento.get('email').hasError('required')) {
                  <mat-error>
                    Campo requerido
                  </mat-error>
                }
                @if (this.formActualizaComplemento.get('email').hasError('invalidEmail')) {
                  <mat-error>
                    De capturar un email válido
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <mat-form-field class="inputFormularioSmall">
                <mat-label>Daños preexistentes:</mat-label>
                <mat-select formControlName="preexistentes" placeholder="Seleccionar">
                  @for (p of preexistentes; track p) {
                    <mat-option [value]="p.id">{{ p.nombre }}</mat-option>
                  }
                </mat-select>
                @if (this.formActualizaComplemento.get('preexistentes').hasError('required')) {
                  <mat-error
                    >Campo
                  requerido</mat-error>
                }
                @if (this.formActualizaComplemento.get('preexistentes').hasError('importeInvalido')) {
                  <mat-error
                    >El
                  campo debe tener un valor</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field class="inputFormularioSmall">
                <mat-label>Tipo ubicación:</mat-label>
                <mat-select formControlName="tipoUbicacion" placeholder="Seleccionar">
                  @for (t of tipoUbicaciones; track t) {
                    <mat-option [value]="t.valor_dato">{{ t.descripl_dato
                    }}</mat-option>
                  }
                </mat-select>
                @if (this.formActualizaComplemento.get('tipoUbicacion').hasError('required')) {
                  <mat-error
                    >Campo
                  requerido</mat-error>
                }
                @if (this.formActualizaComplemento.get('tipoUbicacion').hasError('importeInvalido')) {
                  <mat-error
                    >El
                  campo debe tener un valor</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-md-12 mt-4">
              @if (formActualizaComplemento.get('tipoUbicacion').value && formActualizaComplemento.get('tipoUbicacion').value != 3) {
                <mat-form-field class="inputFormularioSmall"
                  >
                  <mat-label>Subtipo ubicación:</mat-label>
                  <mat-select formControlName="subUbicacion" placeholder="Seleccionar">
                    @for (s of subUbicaciones; track s) {
                      <mat-option [value]="s.valor_dato">{{ s.descripl_dato
                      }}</mat-option>
                    }
                  </mat-select>
                  @if (this.formActualizaComplemento.get('subUbicacion').hasError('required')) {
                    <mat-error
                      >Campo
                    requerido</mat-error>
                  }
                  @if (this.formActualizaComplemento.get('subUbicacion').hasError('importeInvalido')) {
                    <mat-error
                      >El
                    campo debe tener un valor</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <div class="col-md-12">
              <mat-form-field class="inputFormularioSmall">
                <mat-label>Tipo de pérdida:</mat-label>
                <mat-select formControlName="tipoPerdida" placeholder="Seleccionar">
                  @for (p of perdidas; track p) {
                    <mat-option [value]="p.valor_dato">{{ p.descripl_dato
                    }}</mat-option>
                  }
                </mat-select>
                @if (this.formActualizaComplemento.get('tipoPerdida').hasError('required')) {
                  <mat-error
                    >Campo
                  requerido</mat-error>
                }
                @if (this.formActualizaComplemento.get('tipoPerdida').hasError('importeInvalido')) {
                  <mat-error
                    >El
                  campo debe tener un valor</mat-error>
                }
              </mat-form-field>
            </div>
            @if (this.detalleComplementoSiniestro?.['ServicioTaller'] == '0'  && formActualizaComplemento.get('tipoPerdida').value == 2 && this.detalleSiniestroCompleto?.Siniestro?.[0]?.causa != 3) {
              <div class="col-md-12"
                >
                <mat-form-field class="inputFormularioSmall">
                  <mat-label>Estimación daños:</mat-label>
                  <input matInput formControlName="importe" type="text" formatoMoneda tipoFormato="moneda"
                    maxlength="15" />
                    <mat-error>El campo debe tener un valor</mat-error>
                  </mat-form-field>
                </div>
              }

              @if (this.detalleComplementoSiniestro?.['ServicioTaller'] == '0'  && formActualizaComplemento.get('tipoPerdida').value == 2 && this.detalleSiniestroCompleto?.Siniestro?.[0]?.causa != 3) {
                <div class="col-md-12"
                  >
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Corralon destino:</mat-label>
                    <input matInput formControlName="corralonDestino" type="text" UpperCase />
                    <mat-error>El campo debe tener un valor</mat-error>
                  </mat-form-field>
                </div>
              }
            </div>
          </div>



          @if (['DB7', 'DBA',].includes(this.detalleSiniestroCompleto?.Siniestro?.[0]?.sucursalk1) && this.detalleSiniestroCompleto?.Siniestro?.[0]?.causa != 3) {
            <div class="col-md-6"
              >
              <mat-form-field class="inputFormularioSmall">
                <mat-label>Kilometraje:</mat-label>
                <input matInput formControlName="kilometraje" maxlength="6" [OnlyNumber]="true" />
                @if (this.formActualizaComplemento.get('kilometraje').hasError('required')) {
                  <mat-error>Campo
                    requerido
                  </mat-error>
                }
                @if (this.formActualizaComplemento.get('kilometraje').hasError('importeInvalido')) {
                  <mat-error>El
                    campo debe tener un valor diferente de cero
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }

          <div class="col-md-6 d-none">
            <mat-form-field class="inputFormularioSmall">
              <mat-label>Estimación daños:</mat-label>
              <mat-select formControlName="estimacionDanos" placeholder="Seleccionar" formatoMoneda
                tipoFormato="moneda">
                @for (p of perdidas; track p) {
                  <mat-option [value]="p.valor_dato">{{ p.descripl_dato }}</mat-option>
                }
              </mat-select>
              <mat-error>Campo requerido</mat-error>
            </mat-form-field>
          </div>

          @if (![6, 4, 5].includes(this.detalleSiniestroCompleto?.Siniestro?.[0]?.causa) && subCausas.length) {
            <div class="col-md-12"
              >
              <mat-form-field class="inputFormularioSmall">
                <mat-label>Sub causa:</mat-label>
                <mat-select formControlName="subCausa" placeholder="Seleccionar">
                  @for (s of subCausas; track s) {
                    <mat-option [value]="s.cve_subcausa">{{ s.descripcion
                    }}</mat-option>
                  }
                </mat-select>
                @if (this.formActualizaComplemento.get('subCausa').hasError('required')) {
                  <mat-error>Campo
                  requerido</mat-error>
                }
                @if (this.formActualizaComplemento.get('subCausa').hasError('importeInvalido')) {
                  <mat-error>El campo es requerido</mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>

        @if ( this.banderasFechas.fechaInicio || this.banderasFechas.fechaFin || this.banderasFechas.mostrarHoraInicio || this.banderasFechas.mostrarHoraTermino ) {
          <div
            >
            <span>Fechas</span>
          </div>
        }
        <hr>
          @if (this.banderasFechas.fechaInicio || this.banderasFechas.mostrarHoraInicio  ) {
            <div class="row align-items-center m-0 py-4"
              >
              <div class="col-md-3">
                <label for="inicioFechaAtencion">Inicio de atención :</label>
              </div>
              <div class="col-md-9 d-flex gap-2">
                @if (this.banderasFechas.fechaInicio) {
                  <mat-form-field class="campos-administrador" style="width: 90px;"
                    >
                    <input matInput [matDatepicker]="inicioPicker" formControlName="inicioFechaAtencion" readonly>
                    <mat-datepicker-toggle matSuffix [for]="inicioPicker"></mat-datepicker-toggle>
                    <mat-datepicker #inicioPicker></mat-datepicker>
                  </mat-form-field>
                }
                @if (this.banderasFechas.mostrarHoraInicio) {
                  <mat-form-field class="campos-administrador" style="width: 90px;"
                    >
                    <mat-label>Horas:</mat-label>
                    <mat-select formControlName="inicioHoraAtencion" placeholder="HR">
                      @for (hora of horas; track hora) {
                        <mat-option [value]="hora">{{ hora }}</mat-option>
                      }
                    </mat-select>
                    @if (this.formActualizaComplemento.get('inicioHoraAtencion').hasError('required')) {
                      <mat-error
                        >Campo
                      requerido</mat-error>
                    }
                    @if (this.formActualizaComplemento.get('inicioHoraAtencion').hasError('importeInvalido')) {
                      <mat-error
                        >Campo
                      requerido</mat-error>
                    }
                  </mat-form-field>
                }
                @if (this.banderasFechas.mostrarHoraInicio) {
                  <span class="align-self-center">:</span>
                }
                @if (this.banderasFechas.mostrarHoraInicio) {
                  <mat-form-field class="campos-administrador" style="width: 100px;"
                    >
                    <mat-label>Minutos:</mat-label>
                    <mat-select formControlName="inicioMinutoAtencion" placeholder="MIN">
                      @for (minuto of minutos; track minuto) {
                        <mat-option [value]="minuto">{{ minuto }}</mat-option>
                      }
                    </mat-select>
                    @if (this.formActualizaComplemento.get('inicioMinutoAtencion').hasError('required')) {
                      <mat-error
                        >Campo
                      requerido</mat-error>
                    }
                    @if (this.formActualizaComplemento.get('inicioMinutoAtencion').hasError('importeInvalido')) {
                      <mat-error
                        >Campo
                      requerido</mat-error>
                    }
                  </mat-form-field>
                }
              </div>
            </div>
          }

          <!-- Fin de atención -->
          @if (this.banderasFechas.fechaFin || this.banderasFechas.mostrarHoraTermino  ) {
            <div class="row align-items-center m-0 py-4">
              <div class="col-md-3">
                <label for="finFechaAtencion">Fin de atención :</label>
              </div>
              <div class="col-md-9 d-flex gap-2">
                @if (this.banderasFechas.fechaFin) {
                  <mat-form-field class="campos-administrador" style="width: 90px;">
                    <input matInput [matDatepicker]="finPicker" formControlName="finFechaAtencion" readonly>
                    <mat-datepicker-toggle matSuffix [for]="finPicker"></mat-datepicker-toggle>
                    <mat-datepicker #finPicker></mat-datepicker>
                  </mat-form-field>
                }
                @if (this.banderasFechas.mostrarHoraTermino  ) {
                  <mat-form-field class="campos-administrador" style="width: 90px;">
                    <mat-label>Horas:</mat-label>
                    <mat-select formControlName="finHoraAtencion" placeholder="HR">
                      @for (hora of horas; track hora) {
                        <mat-option [value]="hora">{{ hora }}</mat-option>
                      }
                    </mat-select>
                    @if (this.formActualizaComplemento.get('finHoraAtencion').hasError('required')) {
                      <mat-error
                        >Campo
                      requerido</mat-error>
                    }
                    @if (this.formActualizaComplemento.get('finHoraAtencion').hasError('importeInvalido')) {
                      <mat-error
                        >Campo
                      requerido</mat-error>
                    }
                  </mat-form-field>
                }
                @if (this.banderasFechas.mostrarHoraTermino) {
                  <span class="align-self-center">:</span>
                }
                @if (this.banderasFechas.mostrarHoraTermino) {
                  <mat-form-field appearance="fill" class="campos-administrador" style="width: 100px;">
                    <mat-label>Minutos:</mat-label>
                    <mat-select formControlName="finMinutoAtencion" placeholder="MIN">
                      @for (minuto of minutos; track minuto) {
                        <mat-option [value]="minuto">{{ minuto }}</mat-option>
                      }
                    </mat-select>
                    @if (this.formActualizaComplemento.get('finMinutoAtencion').hasError('required')) {
                      <mat-error
                        >Campo
                      requerido</mat-error>
                    }
                    @if (this.formActualizaComplemento.get('finMinutoAtencion').hasError('importeInvalido')) {
                      <mat-error
                        >Campo
                        requerido
                      </mat-error>
                    }
                  </mat-form-field>
                }
              </div>
            </div>
          }

          @if (this.detalleSiniestroCompleto?.Siniestro?.[0]?.causa == 3) {
            <div><span>Robo</span></div>
            <hr>
            }
            <!-- ROBO -->
            @if (this.detalleSiniestroCompleto?.Siniestro?.[0]?.causa == 3) {
              <div class="row">
                <!-- País -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>País:</mat-label>
                    <mat-select formControlName="pais" placeholder="Seleccionar">
                      @for (pais of paises; track pais) {
                        <mat-option [value]="pais.cve_pais">{{ pais.descripcion
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Estado -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Estado:</mat-label>
                    <mat-select formControlName="estado" placeholder="Seleccionar">
                      @for (estado of estados; track estado) {
                        <mat-option [value]="estado.cve_estado">{{
                        estado.descripcion}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Código Postal -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>C.P.:</mat-label>
                    <input matInput formControlName="cp" maxlength="6" [OnlyNumber]="true" />
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>
                <!-- Colonia -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Colonia:</mat-label>
                    <input matInput formControlName="colonia" />
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>
                <!-- Delegación -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Delegación:</mat-label>
                    <mat-select formControlName="municipio" placeholder="Seleccionar">
                      @for (municipio of municipios; track municipio) {
                        <mat-option [value]="municipio.cve_municip">{{
                        municipio.descripcion}}</mat-option>
                      }
                    </mat-select>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>
                <!-- Calle -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Calle:</mat-label>
                    <input matInput formControlName="calle" />
                  </mat-form-field>
                </div>
                <!-- Referencias -->
                <div class="col-md-12">
                  <mat-form-field class="inputFormularioSmall" class="w-100">
                    <mat-label>Referencias:</mat-label>
                    <input matInput formControlName="referencias" />
                  </mat-form-field>
                </div>
                <!-- Fecha registro -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Fecha registro:</mat-label>
                    <input matInput [matDatepicker]="fechaReg" formControlName="fechaRegistro" />
                    <mat-datepicker-toggle matSuffix [for]="fechaReg"></mat-datepicker-toggle>
                    <mat-datepicker #fechaReg></mat-datepicker>
                  </mat-form-field>
                </div>
                <!-- Participantes -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Participantes:</mat-label>
                    <input matInput formControlName="numeroParticipantes" [OnlyNumber]="true" maxlength="2" />
                    @if (this.formActualizaComplemento.get('numeroParticipantes').hasError('importeInvalido')) {
                      <mat-error
                        >El
                        valor no puede ser menor o igual a cero
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <!-- Fecha robo -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Fecha robo:</mat-label>
                    <input matInput [matDatepicker]="fechaRobo" formControlName="fechaRobo" />
                    <mat-datepicker-toggle matSuffix [for]="fechaRobo"></mat-datepicker-toggle>
                    <mat-datepicker #fechaRobo></mat-datepicker>
                  </mat-form-field>
                </div>
                <!-- No. de Acta -->
                <div class="col-md-6">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>No. de Acta:</mat-label>
                    <input matInput formControlName="numeroActa" />
                  </mat-form-field>
                </div>
              </div>
            }
          </form>
        </mat-card>

        <mat-menu #menu="matMenu" yPosition="above" xPosition="before">
          <div [innerHTML]="verificaSerieHTMLSa"></div>
        </mat-menu>